// Water outages from Aquanet and detour notices from ZTM, as data. Two voices,
// one endpoint; the rows they become are the axis's (SPEC-redesign §4.3).

export type Alert = {
  id: string;
  kind: 'water' | 'ztm';
  title: string;
  publishedAt: string;
  lat: number | null;
  lon: number | null;
  url: string;
  lines?: string[];
};

/** "dotyczy linii 6 i 8" — Polish joins the last item with "i". */
export function linesLabel(lines: string[]): string {
  if (!lines.length) return '';
  const head = lines.slice(0, -1).join(', ');
  return `, dotyczy linii ${head ? `${head} i ` : ''}${lines.at(-1)}`;
}
